import React, { useCallback } from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import { ButtonPrimary, ButtonSecondary } from '@spotify-internal/encore-web';

import { useT } from 'client/i18n/hooks/useT';
import {
  trackSwitchCloseModalClick,
  trackRiversideSwitchSignupClicked,
} from './events';

export function SwitchModal({
  partnerName,
  dismissSwitchModal,
}: {
  partnerName: string;
  dismissSwitchModal: () => void;
}) {
  const t = useT();
  const switchUrl = `/switch?partner=${partnerName}`;

  const nevermindClicked = useCallback(() => {
    trackSwitchCloseModalClick();
    dismissSwitchModal();
  }, [dismissSwitchModal]);

  const redirectClicked = useCallback(() => {
    trackRiversideSwitchSignupClicked();
  }, []);

  return (
    <Modal
      isShowing
      isShowingCloseButton
      onClose={dismissSwitchModal}
      aria-labelledby="integration-connection-switch-modal"
    >
      <Modal.Title id="integration-connection-switch-modal">
        {t(
          'IntegrationConnectionScreen.SwitchModal.Title',
          'Switching your podcast to Anchor',
          'The title for the switch modal in the integration connection flow'
        )}
      </Modal.Title>
      <Modal.Body>
        {t(
          'IntegrationConnectionScreen.SwitchModal.Body',
          'Switching is easy, just provide your RSS feed and create an Anchor account. After you switch, you’ll need to go back to Riverside.fm to import your file.',
          'The body for the switch modal in the integration connection flow'
        )}
      </Modal.Body>
      <Modal.Footer>
        <ButtonSecondary onClick={nevermindClicked}>
          {t(
            'IntegrationConnectionScreen.SwitchModal.DismissAction',
            'Nevermind',
            'The action for the switch modal in the integration connection flow when user decides against importing to Anchor'
          )}
        </ButtonSecondary>
        <ButtonPrimary as="a" href={switchUrl} onClick={redirectClicked}>
          {t(
            'IntegrationConnectionScreen.SwitchModal.ContinueAction',
            'Switch',
            'The action for the switch modal in the integration connection flow when user decides to continue importing to Anchor'
          )}
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
}
